
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-emerald-900 text-amber-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              alt="SheWearHouse Logo"
              className="h-16 w-auto mb-4"
              src="https://static.readdy.ai/image/dfd7835b0b48b5e53834bc8bf5a32140/5d84906f6f014eb6da45b21c4eedd3f4.png"
            />
            <p className="text-amber-200 mb-6 leading-relaxed text-sm">
              Celebrating Islamic culture through elegant modest wear and handcrafted accessories. Quality, tradition, and style in every piece.
            </p>
            <div className="flex gap-4">
              {[
                { icon: 'ri-instagram-line', href: 'https://instagram.com' },
                { icon: 'ri-facebook-fill', href: 'https://facebook.com' },
                { icon: 'ri-pinterest-fill', href: 'https://pinterest.com' },
                { icon: 'ri-whatsapp-line', href: 'https://wa.me/' },
              ].map(s => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center border-2 border-amber-500 rounded-full hover:bg-amber-500 hover:text-emerald-900 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm uppercase text-amber-200 font-medium mb-4 tracking-wider">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: 'Shop All', to: '/products' },
                { label: 'Abayas', to: '/clothing' },
                { label: 'Accessories', to: '/accessories' },
                { label: 'Girls Collection', to: '/themes' },
                { label: 'Our Story', to: '/about' },
              ].map(l => (
                <li key={l.label}>
                  <Link to={l.to} className="text-amber-50 hover:text-amber-400 transition-colors cursor-pointer text-sm">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Care */}
          <div>
            <h3 className="text-sm uppercase text-amber-200 font-medium mb-4 tracking-wider">Customer Care</h3>
            <ul className="space-y-3">
              {[
                { label: 'Contact Us', to: '/contact' },
                { label: 'Track Order', to: '/contact' },
                { label: 'Returns', to: '/contact' },
                { label: 'FAQs', to: '/contact' },
                { label: 'Privacy Policy', to: '/contact' },
                { label: 'Terms of Service', to: '/contact' },
              ].map(l => (
                <li key={l.label}>
                  <Link to={l.to} className="text-amber-50 hover:text-amber-400 transition-colors cursor-pointer text-sm">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Get In Touch */}
          <div>
            <h3 className="text-sm uppercase text-amber-200 font-medium mb-4 tracking-wider">Get In Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-amber-500 text-xl mt-0.5"></i>
                <p className="text-amber-50 text-sm">support@shewearhouse.com</p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-amber-500 text-xl mt-0.5"></i>
                <p className="text-amber-50 text-sm">+1 (339) 234-6017</p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-amber-500 text-xl mt-0.5"></i>
                <p className="text-amber-50 text-sm">Burlington, MA 01803</p>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-amber-500 text-xl mt-0.5"></i>
                <div>
                  <p className="text-amber-50 text-sm">Mon – Sat: 9AM – 6PM</p>
                  <p className="text-amber-200 text-xs">Sunday: Closed</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-amber-500/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-amber-200">© 2025 SheWearHouse. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <span className="text-sm text-amber-200">Secure Checkout</span>
              <i className="ri-lock-line text-amber-500"></i>
              <div className="flex gap-2">
                <i className="ri-visa-line text-2xl text-amber-200"></i>
                <i className="ri-mastercard-line text-2xl text-amber-200"></i>
                <i className="ri-paypal-line text-2xl text-amber-200"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
